<template>
  <section class="register pt-16">
    <v-dialog v-model="soldOutDialog" width="unset" max-width="420">
      <v-card class="pt-6 pb-4 px-5">
        <h5 class="mb-2">{{ registrationData.soldOutTitle }}</h5>
        <v-card-text class="pa-0">
          {{ registrationData.soldOutText }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#FFA903" text @click="soldOutDialog = false">
            {{ registrationData.soldOutButtonTitle }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="!isActiveRegister" class="register__title py-12 pl-md-10 pl-4">
      <h2>
        {{ registrationData.registrationWillOpenSoonTitle }}
      </h2>
    </div>
    <v-row v-else class="" style="min-height: 100vh" no-gutters>
      <v-col
        cols="12"
        :style="{
          'padding-right': $vuetify.breakpoint.mdAndUp ? '7rem' : '20px'
        }"
        class="col-md-7 py-12 pl-md-10 pl-4"
      >
        <div class="register__title">
          <!--          <h2>-->
          <!--            {{-->
          <!--              tab === 0-->
          <!--                ? registrationData.registrationDate-->
          <!--                : registrationData.singleDayRegistrationDate-->
          <!--            }}-->
          <!--          </h2>-->
          <h2>
            {{
              tab === 0
                ? registrationData.registrationTitle
                : registrationData.singleDayRegistrationTitle
            }}
          </h2>
        </div>
        <div class="divider my-8" />
        <div class="register__form mt-5">
          <p>
            {{ registrationData.registrationClosed }}
          </p>
        </div>
        <!-- <div class="divider my-8" />
        <div>
          <v-tabs
            slider-color="#FFA903"
            color="#FFA903"
            background-color="transparent"
            v-model="tab"
            class="tabs"
            :key="{ locale }"
            @change="onTabChangeHandler"
          >
            <v-tab
              v-for="tab in registrationData.tabs"
              :key="tab.id"
              class="tabItem"
            >
              {{ tab.value }}
            </v-tab>
          </v-tabs>
        </div>
        <div class="register__form mt-5">
          <p class="my-0">
            {{
              tab === 1
                ? registrationData.adultFieldLabel
                : registrationData.singleDayAdultFieldLabel
            }}
          </p>
          <div class="register__form-seats">
            <v-row class="align-center">
              <v-col cols="6">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="secondary-btn"
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      style="border-color: #CECED8 !important"
                      width="100%"
                      height="40"
                    >
                      {{ getSeatsText(seatsChoose) }}
                      <v-icon right large>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(count, index) in adultsOptions"
                      :key="index"
                      class="px-5"
                      style="cursor: pointer"
                      @click="seatsChange(count)"
                    >
                      {{ getSeatsText(count) }}
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-checkbox
                  class="register__form-kind ml-8"
                  color="#FFA903"
                  off-icon="mdi-checkbox-blank"
                  value="ok"
                  :label="registrationData.kidsLabel"
                  v-model="kids"
                >
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="kids">
              <v-col cols="6">
                <p>{{ registrationData.teenFieldLabel }}</p>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="secondary-btn"
                      outlined
                      style="border-color: #CECED8 !important"
                      v-bind="attrs"
                      v-on="on"
                      width="100%"
                      height="40"
                    >
                      {{ getSeatsText(littleKidsChoose) }}
                      <v-icon right large>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(count, index) in littleKidsOptions"
                      :key="index"
                      class="px-5"
                      style="cursor: pointer"
                      @click="littleKidsChange(count)"
                    >
                      {{ getSeatsText(count) }}
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <p>{{ registrationData.kidsFieldLabel }}</p>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="secondary-btn"
                      outlined
                      style="border-color: #CECED8 !important"
                      v-bind="attrs"
                      v-on="on"
                      width="100%"
                      height="40"
                    >
                      {{ getSeatsText(teensChoose) }}
                      <v-icon right large>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(count, index) in teensOptions"
                      :key="index"
                      class="px-5"
                      style="cursor: pointer"
                      @click="teensChange(count)"
                    >
                      {{ getSeatsText(count) }}
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </div>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card min-height="300px" flat tile>
                <v-card-subtitle class="tabText mt-2">
                  {{ registrationData.registrationDescription }}
                </v-card-subtitle>
                <div class="register__form-bed mt-7">
                  <v-btn
                    class="register__form-bed-btn"
                    outlined
                    tile
                    width="100%"
                    height="4.4rem"
                    @click="bedsChange(2)"
                  >
                    <div
                      class="d-flex"
                      style="font-family: Roboto, sans-serif !important"
                    >
                      <div
                        class="register__form-bed-btn-radio mr-5"
                        :class="{ 'active-radio': beds === 2 }"
                      ></div>
                      {{ registrationData.bedSingleTitle }}
                    </div>
                    <div class="d-none d-sm-flex">
                      <img
                        class="register__form-bed-img"
                        src="@/assets/img/bed1.svg"
                        alt=""
                      />
                      <img
                        class="register__form-bed-img"
                        src="@/assets/img/bed1.svg"
                        alt=""
                      />
                    </div>
                  </v-btn>
                  <v-btn
                    class="register__form-bed-btn"
                    outlined
                    tile
                    width="100%"
                    height="4.4rem"
                    @click="bedsChange(1)"
                  >
                    <div
                      class="d-flex"
                      style="font-family: Roboto, sans-serif !important"
                    >
                      <div
                        class="register__form-bed-btn-radio mr-5"
                        :class="{ 'active-radio': beds === 1 }"
                      ></div>
                      {{ registrationData.bedDoubleTitle }}
                    </div>
                    <img
                      class="register__form-bed-img d-none d-sm-flex"
                      src="@/assets/img/bed2.svg"
                      alt=""
                    />
                  </v-btn>
                </div>
                <div
                  class="register__form-bottom d-md-flex justify-end align-center mt-7"
                >
                  <v-btn
                    class="main-btn register__form-bottom-btn"
                    min-width="8rem"
                    height="40px"
                    @click="findRooms"
                  >
                    {{ registrationData.bookButtonTitle }}
                  </v-btn>
                </div>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <SingleDayTab
                :adultsCount="seatsChoose"
                :childCount="kids ? teensChoose : 0"
                :babyCount="kids ? littleKidsChoose : 0"
                @onSubmit="onSingleRegisterClick"
              />
            </v-tab-item>
          </v-tabs-items>
        </div> -->
      </v-col>
      <!-- <v-col
        cols="12"
        class="col-md-5 pl-md-15 py-12 pr-md-10 pl-4 pr-4"
        style="background-color: #F9F7FC"
        ref="chooseRoom"
      >
        <choose-hotel-room
          :rooms="roomsInfo.rooms"
          :total="roomsInfo.total"
          v-if="chooseRoom"
        ></choose-hotel-room>
      </v-col> -->
    </v-row>
  </section>
</template>

<script>
import { fetchRooms, fetchCategories } from "@/api/registration";
import { checkKeyRoom } from "@/utils/sessionKey";

export default {
  name: "Register",
  components: {},
  beforeRouteEnter(to, from, next) {
    checkKeyRoom() || localStorage.getItem("single-page")
      ? next("book")
      : next();
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    adultsOptions() {
      const adults = this.categories?.adults;
      const maxCount = adults?.count || 0;
      return Array.from({ length: maxCount }, (_, i) => i + 1);
    },
    littleKidsOptions() {
      let availableCount = 5;
      if (this.categories && !this.isSingleDay) {
        const adultsCount = this.seatsChoose;
        const teensCount = this.teensChoose;
        const allCount = this.categories?.maxCount;
        const babiesCount = this.categories.babies?.count;

        availableCount = Math.min(
          babiesCount,
          allCount - adultsCount - teensCount
        );
      }
      return [...Array(availableCount + 1).keys()];
    },
    teensOptions() {
      let availableCount = 5;
      if (this.categories && !this.isSingleDay) {
        const adultsCount = this.seatsChoose;
        const babiesCount = this.littleKidsChoose;
        const allCount = this.categories?.maxCount;
        const teensCount = this.categories.children?.count;

        availableCount = Math.min(
          teensCount,
          allCount - adultsCount - babiesCount
        );
      }
      return [...Array(availableCount + 1).keys()];
    },
    calculatedSingleRegisterPrice() {
      try {
        const { adult, child } = this.$store.getters.getSingleDayPrice;
        return (
          Number(adult) * this.seatsChoose + Number(child) * this.teensChoose
        );
      } catch (error) {
        return 0;
      }
    },
    isSingleDay() {
      return this.tab !== 0;
    },
    registrationData() {
      return this.$t("registration");
    }
  },
  data: () => ({
    categories: null,
    seatsChoose: 1,
    littleKidsChoose: 0,
    teensChoose: 0,
    kids: false,
    beds: 2,
    isVolunteer: false,
    chooseRoom: false,
    roomsInfo: {},
    tab: null,
    isActiveRegister: true,

    soldOutDialog: false
  }),
  methods: {
    onTabChangeHandler() {
      this.teensChoose = 0;
      this.littleKidsChoose = 0;
      this.seatsChoose = 1;
    },
    seatsChange(count) {
      this.teensChoose = 0;
      this.littleKidsChoose = 0;
      this.seatsChoose = count;
      this.chooseRoom = false;
    },

    littleKidsChange(count) {
      this.littleKidsChoose = count;
      this.chooseRoom = false;
    },

    teensChange(count) {
      this.teensChoose = count;
      this.chooseRoom = false;
    },

    bedsChange(bedsCount) {
      this.beds = bedsCount;
      this.chooseRoom = false;
    },

    getSeatsText(count) {
      if (count === 0) return 0;
      if (count === 1) return `1 ${this.registrationData.participantLabel}`;
      return `${count} ${this.registrationData.multipleParticipantLabel}`;
    },

    async getCategories() {
      try {
        const response = await fetchCategories();
        this.categories = response;
      } catch (error) {
        console.error(error);
      }
    },

    async findRooms() {
      this.soldOutDialog = false;
      const result = await fetchRooms({
        adults: this.seatsChoose,
        children: this.teensChoose,
        babies: this.littleKidsChoose,
        beds: this.beds
      });
      if (result) this.chooseRoom = true;
      this.roomsInfo = result;
      this.$store.dispatch("setSessionKey", {
        key: result.sessionKey,
        timeout: result.sessionTimeout
      });
      this.$store.dispatch("setFormInfo", {
        adults: this.seatsChoose,
        children: this.teensChoose,
        babies: this.littleKidsChoose
      });
      if (this.$vuetify.breakpoint.smAndDown) {
        const chooseRoom = this.$refs["chooseRoom"];
        await this.$vuetify.goTo(chooseRoom);
      }
    },

    async onSingleRegisterClick({ price, food }) {
      await this.$store.dispatch("setFormInfo", {
        adults: this.seatsChoose,
        children: this.teensChoose,
        babies: this.littleKidsChoose
      });
      await this.$store.dispatch("setRoom", {
        title: "Registration",
        price,
        food
      });
      localStorage.setItem("single-page", "1");
      this.$router.push("/book");
    }
  },
  mounted() {
    this.getCategories();
  }
};
</script>

<style lang="sass" scoped>
@import "./src/assets/style/vars"

.register
  color: $dark
  min-height: 100vh
  &__form
    p
      font-weight: bold
    &-bed
      &-img
        height: 1.8rem
        width: 2.4rem
      &-btn
        border-color: rgba($second, .2)
        text-transform: unset
        &-radio
          width: 20px
          height: 20px
          border: 1px solid #CECED8
          box-sizing: border-box
          border-radius: 50%
          transition: all .2s ease
    &-bottom
      &-btn
        text-transform: unset
        font-size: 16px !important
        line-height: 23px !important

.active-radio
  border: 6px solid #FFA903

.tabItem
  text-transform: unset
  @media (max-width: 900px)
    font-size: 14px
    max-width: 50vw

.tabText
  width: 100%
  padding: 0
  font-size: 1rem !important
</style>

<style lang="sass">
.register__form-seats, .register__form-bed-btn
  .v-btn__content
    justify-content: space-between
    font-family: Roboto, sans-serif !important
    font-style: normal
    font-weight: normal
    font-size: 16px
    line-height: 24px

.v-slide-group__prev
  display: none !important
</style>
